import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components/macro';
import { responsive } from '../resources/constantes.json';
import { useIsDesktop } from '../hooks/useMediaQuery';
import { AnimatePresence, motion } from 'framer-motion';
import { useEleccion } from '../contexts/eleccionContext';
import useWindowWidth from '../hooks/useWindowWidth';
import { themes } from '../styles/themes';

const LayoutResultados = ({
  components = [<></>, <></>],
  keyForRerenderLeftSide,
}) => {
  const targetRef = useRef();
  const [animating, setAnimating] = useState(false);
  const [children, setChildren] = useState(components);
  const { selectedTab } = useEleccion();
  const isDesktop = useIsDesktop();
  const windowWidth = useWindowWidth().width;
  const leftSideRef = useRef(null);

  useEffect(() => {
    if (!animating) setChildren(components);
  }, [animating, components]);

  const onTabChange = () => {
    if (leftSideRef.current) {
      leftSideRef.current.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }
  };

  // Utiliza useEffect para controlar los cambios en los datos
  useEffect(() => {
    if (selectedTab?.id) {
      onTabChange();
    }
  }, [selectedTab.id]);

  return (
    <>
      <ContainerLayout
        animate={isDesktop ? selectedTab?.id : 'mobile'}
        onAnimationStart={() => setAnimating(true)}
        onAnimationComplete={() => setAnimating(false)}
        variants={{
          territorios: {
            gridTemplateColumns:
              isDesktop && windowWidth <= 1200 ? '60% 40%' : '50% 50%',
          },
          votosPartidos: {
            gridTemplateColumns: '50% 50%',
          },
          mobile: {
            gridTemplateColumns: '1fr',
          },
        }}
        transition={{
          delay: 0.2,
        }}
        initial="territorios"
      >
        <LeftSide key={keyForRerenderLeftSide ?? 'key'} ref={leftSideRef}>
          {React.cloneElement(children[0], { animating })}
        </LeftSide>
        <AnimatePresence>
          {!animating && children[1] && (
            <motion.div
              variants={{
                show: {
                  scale: 1,
                },
                hide: {
                  scale: 0,
                },
              }}
              transition={{
                duration: 0.2,
              }}
              animate="show"
              initial="hide"
              exit="hide"
            >
              <RightSide ref={targetRef}>{children[1]}</RightSide>
            </motion.div>
          )}
        </AnimatePresence>
      </ContainerLayout>
    </>
  );
};

const ContainerLayout = styled(motion.div)`
  display: grid;
  grid-template-rows: 100%;
  grid-template-areas: 'table graphic';
  @media (max-width: ${responsive.tablet}px) {
    display: flex;
    flex-direction: column;
  }

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    padding: 2rem 2rem 0 2rem;
  }
`;
const LeftSide = styled.div`
  overflow-y: auto;
  margin-right: 10px;
  height: 100%;
  grid-area: table;
  padding-right: 1rem;
  &::-webkit-scrollbar {
    width: 10px;
  }
  &::-webkit-scrollbar-track {
    background: ${themes.tarjetasCandidaturas.backgroundColor};
    border-radius: 10px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d8dfea;
    border-radius: 10px;
  }
  @media (max-width: ${responsive.tablet}px) {
    width: 100%;
    overflow-y: unset;
    /* max-height: 70vh; */
    height: auto;
    order: 2;
    margin-top: 5rem;
  }
  @media (max-width: ${responsive.mobile}px) {
    /* &::-webkit-scrollbar {
      width: 5px;
    } */
  }
`;

const RightSide = styled.div`
  height: 100%;
  overflow: hidden;
  grid-area: graphic;
  @media (max-width: ${responsive.tablet}px) {
    width: 100%;
    order: 1;
  }
`;
export default LayoutResultados;
